module.exports = __webpack_public_path__ + "img/userB10.c9d4d38c.jpg";